import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  mutations: {
    setVpa(state, val) {
      state.vpa = val
    }
  },
  getters: {
    // ZONE CALCULATIONS
    calcYrOneCl: (state) => (index) => {
      let zone = state.mzs[index]
      let d = zone.yrOneCropEst
      let e = state.vpa
      let c = zone.yrOneMvs
      let calc = (((d * 2000) / e) / c)
      return calc
    },
    calcYrOneJss: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let f = getters.calcYrOneCl(index)
      let calc
      if (f > 20) {
        calc = (17.174 - 1.846) - ((f - 20) * 0.1341)
      } else {
        calc = ((0.0002 * (f * f * f)) - (0.01 * (f * f)) + (0.0277 * (f)) + 17.174)
      }
      return calc
    },
    calcYrTwoMvsChg: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let f = getters.calcYrOneCl(index)
      let calc = ((-0.0309 * f) + 0.4824)
      return calc
    },
    calcYrOneMdlTrgCropVrm: (state) => (index) => {
      let zone = state.mzs[index]
      let c = zone.yrOneMvs
      let calc = ((-0.5608 * (c * c)) + (4.0185 * (c)) + (2.4391))
      return calc
    },
    //ISSUE
    calcYrTwoMvs: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let c = zone.yrOneMvs
      let h = getters.calcYrTwoMvsChg(index)
      let calc = c + h
      return calc
    },
    calcYrTwoMvsVrm: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let c = zone.yrOneMvs
      let u = getters.calcYrTwoMvsVrmChg(index)
      let calc = c + u
      return calc
    },
    calcYrTwoCropPot: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let j = getters.calcYrTwoMvs(index)
      let calc = ((-0.5608 * (j * j)) + (4.0185 * (j)) + (2.4391))
      return calc
    },
    calcYrTwoCropPotChg: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let k = getters.calcYrTwoCropPot(index)
      let i = getters.calcYrOneMdlTrgCropVrm(index)
      let calc = k - i
      return calc
    },
    calcYrOneTrgCropVrm: (state) => (index) => {
      let zone = state.mzs[index]
      let o = zone.desClVrm
      let c = zone.yrOneMvs
      let e = state.vpa
      let calc = (((o * c) * e) / 2000)
      return calc
    },
    calcYrOneTrgCropVrmChg: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let p = getters.calcYrOneTrgCropVrm(index)
      let d = zone.yrOneCropEst
      let calc = p - d
      return calc
    },
    calcYrOneCropVrm: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let q = getters.calcYrOneTrgCropVrmChg(index)
      let p = getters.calcYrOneTrgCropVrm(index)
      let d = zone.yrOneCropEst
      let calc
      if (q < 0) {
        calc = p
      } else {
        calc = d
      }
      return calc
    },
    calcYrOneClVrm: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let r = getters.calcYrOneCropVrm(index)
      let e = state.vpa
      let c = zone.yrOneMvs
      let calc = (((r * 2000) / e) / c)
      return calc
    },
    calcYrOneJssVrm: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let s = getters.calcYrOneClVrm(index)
      let o = zone.desClVrm
      let calc
      if (o > 20) {
        calc = (17.174 - 1.846) - ((o - 20) * 0.1341)
      } else {
        calc = ((0.0002 * (s * s * s)) - (0.01 * (s * s)) + (0.0277 * (s)) + 17.174)
      }
      return calc
    },
    calcYrTwoMvsVrmChg: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let s = getters.calcYrOneClVrm(index)
      let calc = ((-0.0309 * s) + 0.4824)
      return calc
    },
    calcYrTwoCropPotVrm: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let v = getters.calcYrTwoMvsVrm(index)
      let calc = ((-0.5608 * (v * v)) + (4.0185 * (v)) + (2.4391))
      return calc
    },
    calcYrTwoCropPotVrmChg: (state, getters) => (index) => {
      let zone = state.mzs[index]
      let w = getters.calcYrTwoCropPotVrm(index)
      let i = getters.calcYrOneMdlTrgCropVrm(index)
      let calc = w - i
      return calc
    },
    //
    // TOTAL CALCULATIONS
    //
    calcAreaPctTotal: state => {
      let output = 0
      for (let i = 0; i < state.mzs.length; i++) {
        output = output + state.mzs[i].areaPct
      }
      return output
    },
    calcYrOneJssTotal: (state, getters) => {
      let calc = 0
      for (let i = 0; i < state.mzs.length; i++) {
        let zone = state.mzs[i]
        let g = getters.calcYrOneJss(i)
        let b = zone.areaPct
        calc = calc + (g * (b / 100))
      }
      return calc
    },
    calcYrTwoCropPotChgTotal: (state, getters) => {
      let calc = 0
      for (let i = 0; i < state.mzs.length; i++) {
        let zone = state.mzs[i]
        let l = getters.calcYrTwoCropPotChg(i)
        let b = zone.areaPct
        calc = calc + (l * (b / 100))
      }
      return calc
    },
    calcYrOneCropEstTotal: (state) => {
      let calc = 0
      for (let i = 0; i < state.mzs.length; i++) {
        let zone = state.mzs[i]
        let d = zone.yrOneCropEst
        let b = zone.areaPct
        calc = calc + (d * (b / 100))
      }
      return calc
    },
    calcYrOnePpaTotal: (state, getters) => {
      let g = getters.calcYrOneJssTotal
      let d = getters.calcYrOneCropEstTotal
      let price;
      if (g < 14.5) {
        price = 0
      } else if (g > 21) {
        price = 357.60
      } else {
        for (let i = 0; i < state.paymentScale.length; i++) {
          if (g > state.paymentScale[i].jss) {
            price = state.paymentScale[i].payment
          }
        }
      }
      let calc = price * d
      return calc
    },
    calcYrTwoPpaPotChgTotal: (state, getters) => {
      let l = getters.calcYrTwoCropPotChgTotal
      // This is based on a balanced $250 dollar average price per ton
      let calc = l * 250
      return calc
    },
    calcYrOneTrgCropVrmTotal: (state, getters) => {
      let calc = 0
      for (let i = 0; i < state.mzs.length; i++) {
        let zone = state.mzs[i]
        let p = getters.calcYrOneTrgCropVrm(i)
        let b = zone.areaPct
        calc = calc + (p * (b / 100))
      }
      return calc
    },
    calcYrOneCropVrmTotal: (state, getters) => {
      let calc = 0
      for (let i = 0; i < state.mzs.length; i++) {
        let zone = state.mzs[i]
        let r = getters.calcYrOneCropVrm(i)
        let b = zone.areaPct
        calc = calc + (r * (b / 100))
      }
      return calc
    },
    calcYrOneJssVrmTotal: (state, getters) => {
      let calc = 0
      for (let i = 0; i < state.mzs.length; i++) {
        let zone = state.mzs[i]
        let t = getters.calcYrOneJssVrm(i)
        let b = zone.areaPct
        calc = calc + (t * (b / 100))
      }
      return calc
    },
    calcYrTwoCropPotChgVrmTotal: (state, getters) => {
      let calc = 0
      for (let i = 0; i < state.mzs.length; i++) {
        let zone = state.mzs[i]
        let x = getters.calcYrTwoCropPotVrmChg(i)
        let b = zone.areaPct
        calc = calc + (x * (b / 100))
      }
      return calc
    },
    calcYrOnePpaVrmTotal: (state, getters) => {
      let t = getters.calcYrOneJssVrmTotal
      let r = getters.calcYrOneCropVrmTotal
      let price;
      if (t < 14.5) {
        price = 0
      } else if (t > 21) {
        price = 357.60
      } else {
        for (let i = 0; i < state.paymentScale.length; i++) {
          if (t > state.paymentScale[i].jss) {
            price = state.paymentScale[i].payment
          }
        }
      }
      let calc = price * r
      return calc
    },
    calcYrTwoPpaPotChgVrmTotal: (state, getters) => {
      let x = getters.calcYrTwoCropPotChgVrmTotal
      // This is based on a balanced $250 dollar average price per ton
      let calc = x * 250
      return calc
    }
  },
  state: {
    mzs: [
      {
        areaPct: 25,
        yrOneMvs: 1,
        yrOneCropEst: 5,
        desClVrm: 11,
        showDetails: false,
        modalClass: 'hidden'
      },
      {
        areaPct: 25,
        yrOneMvs: 2,
        yrOneCropEst: 10,
        desClVrm: 11,
        showDetails: false,
        modalClass: 'hidden'
      },
      {
        areaPct: 25,
        yrOneMvs: 3,
        yrOneCropEst: 12,
        desClVrm: 11,
        showDetails: false,
        modalClass: 'hidden'
      },
      {
        areaPct: 25,
        yrOneMvs: 4,
        yrOneCropEst: 17,
        desClVrm: 11,
        showDetails: false,
        modalClass: 'hidden'
      }
    ],
    vpa: 605,
    paymentScale: [
      {jss:14.50, payment:147.60},
      {jss:14.60, payment:154.80},
      {jss:14.70, payment:162.00},
      {jss:14.80, payment:169.20},
      {jss:14.90, payment:176.40},
      {jss:15.00, payment:183.60},
      {jss:15.10, payment:190.80},
      {jss:15.20, payment:198.00},
      {jss:15.30, payment:205.20},
      {jss:15.40, payment:212.40},
      {jss:15.50, payment:219.60},
      {jss:15.60, payment:223.20},
      {jss:15.70, payment:226.80},
      {jss:15.80, payment:230.40},
      {jss:15.90, payment:234.00},
      {jss:16.00, payment:237.60},
      {jss:16.10, payment:240.00},
      {jss:16.20, payment:242.40},
      {jss:16.30, payment:244.80},
      {jss:16.40, payment:247.20},
      {jss:16.50, payment:249.60},
      {jss:16.60, payment:252.00},
      {jss:16.70, payment:254.40},
      {jss:16.80, payment:256.80},
      {jss:16.90, payment:259.20},
      {jss:17.00, payment:261.60},
      {jss:17.10, payment:264.00},
      {jss:17.20, payment:266.40},
      {jss:17.30, payment:268.80},
      {jss:17.40, payment:271.20},
      {jss:17.50, payment:273.60},
      {jss:17.60, payment:276.00},
      {jss:17.70, payment:278.40},
      {jss:17.80, payment:280.80},
      {jss:17.90, payment:283.20},
      {jss:18.00, payment:285.60},
      {jss:18.10, payment:288.00},
      {jss:18.20, payment:290.40},
      {jss:18.30, payment:292.80},
      {jss:18.40, payment:295.20},
      {jss:18.50, payment:297.60},
      {jss:18.60, payment:300.00},
      {jss:18.70, payment:302.40},
      {jss:18.80, payment:304.80},
      {jss:18.90, payment:307.20},
      {jss:19.00, payment:309.60},
      {jss:19.10, payment:312.00},
      {jss:19.20, payment:314.40},
      {jss:19.30, payment:316.80},
      {jss:19.40, payment:319.20},
      {jss:19.50, payment:321.60},
      {jss:19.60, payment:324.00},
      {jss:19.70, payment:326.40},
      {jss:19.80, payment:328.80},
      {jss:19.90, payment:331.20},
      {jss:20.00, payment:333.60},
      {jss:20.10, payment:336.00},
      {jss:20.20, payment:338.40},
      {jss:20.30, payment:340.80},
      {jss:20.40, payment:343.20},
      {jss:20.50, payment:345.60},
      {jss:20.60, payment:348.00},
      {jss:20.70, payment:350.40},
      {jss:20.80, payment:352.80},
      {jss:20.90, payment:355.20},
      {jss:21.00, payment:357.60}
    ]
  }
})



// WEBPACK FOOTER //
// ./src/store.js